import { Injectable } from "@angular/core";
import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent, HttpResponse } from "@angular/common/http";
import { Observable } from "rxjs";
import { NonceService } from '../services/nonce.service';
import { tap } from "rxjs/operators";

@Injectable()

export class NonceInterceptor implements HttpInterceptor {
    constructor(private noonceservice: NonceService){}
    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        return next.handle(req).pipe(
            tap(event => {
                if(event instanceof HttpResponse){
                    const nonceHeader = event.headers.get('X-Nonce');
                    if(nonceHeader){
                        this.noonceservice.setNonce(nonceHeader);
                    }
                }
            })
        )
    }
}


// WEBPACK FOOTER //
// ./src/app/security/nonce.interceptor.ts